import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISCMShopDetail, ISCMShopSearchFields, shopService, ISCMShopFormFields, ISCMShopInsert, ISCMShopUpdate } from "./shopService";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "../../../utils/constants";
import { ISearchPage } from "../../../types/FmsTypes";
import { transPgToPagination } from "../../../utils/utils";
import { globalPrompt } from "../../../components/YhMessage";

interface ISCmShopDrawerType {
    visible: boolean,
    mode: "add" | "edit"
}

export const useShopModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<ISCMShopDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<ISCMShopSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: ISCMShopSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await shopService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: ISCMShopSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    /**
     * 详情
     */
    const initShopDrawer: ISCmShopDrawerType = { visible: false, mode: "add" }
    const [shopDrawer, setShopDrawer] = useState<ISCmShopDrawerType>(initShopDrawer);
    const setIShopDrawer = (str?: "add" | "edit") => setShopDrawer(str ? { visible: true, mode: str } : initShopDrawer);

    //根据id查询
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? { ...filters[0], status: !!!filters[0]?.status, details: filters[0]?.details.map(item => item.bentityCode) } : null;
    };

    const insertShop = async (val: ISCMShopInsert) => {
        let { retData } = await shopService.insert(val);
        if (retData) {
            loadData();
            setIShopDrawer();
            // shopLoadDataAll();
            globalPrompt("message", { text: "门店新增成功", type: "success" })
        } else {
            globalPrompt("message", { text: "门店新增失败", type: "error" });
        }
    }

    //表单编辑 Api
    const editShop = async (val: ISCMShopInsert) => {
        let { retData } = await shopService.update({ ...val, id: selectedRowKeys[0] });
        if (retData) {
            loadData();
            setIShopDrawer();
            // shopLoadDataAll();
            globalPrompt("message", { text: "门店修改成功", type: "success" })
        } else {
            globalPrompt("message", { text: "门店修改失败", type: "error" });
        }
    }

    //启用 禁用 api
    const disableShop = async (id: string, status: number) => {
        let { retData } = await shopService.disable(id, status);
        retData ?
            loadData() && globalPrompt("message", { text: "操作成功", type: "success" })
            : globalPrompt("message", { text: "操作失败", type: "error" });
    };

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        /***method***/
        shopDrawer, setIShopDrawer,
        getSelectedRowData,
        insertShop,
        editShop,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        disableShop,
    }
});